// Build-time config. Vite's import.meta.env is replaced by this: Next only inlines literal
// process.env.NEXT_PUBLIC_* reads, so every key is spelled out here.
const nodeEnv = process.env.NODE_ENV;

export const ENV = {
  DEV: nodeEnv !== "production",
  PROD: nodeEnv === "production",
  VITE_BACKEND_API_URI: process.env.NEXT_PUBLIC_HAMI_BACKEND_API_URI,
  VITE_BACKEND_WS_ORIGIN: process.env.NEXT_PUBLIC_HAMI_BACKEND_WS_ORIGIN,
  VITE_BACKEND_PROXY_TARGET: process.env.NEXT_PUBLIC_HAMI_BACKEND_PROXY_TARGET,
  VITE_AUTH_ME_URL: process.env.NEXT_PUBLIC_HAMI_AUTH_ME_URL,
  VITE_AUDIO_TO_TEXT_URL: process.env.NEXT_PUBLIC_HAMI_AUDIO_TO_TEXT_URL,
  VITE_SIDEBAR_DATA_URL: process.env.NEXT_PUBLIC_HAMI_SIDEBAR_DATA_URL,
  VITE_NATIVE_PUSH_ENABLED: process.env.NEXT_PUBLIC_HAMI_NATIVE_PUSH_ENABLED,
  VITE_NATIVE_FCM_CONFIGURED: process.env.NEXT_PUBLIC_HAMI_NATIVE_FCM_CONFIGURED,
};
